import React from 'react';
import GenericPopover from "@Popover/components/GenericPopover";
import PricePopoverTrigger from "@Pages/stationToStation/features/pricePopover/components/PricePopoverTrigger";
import PricePopoverOverlay from "@Pages/stationToStation/features/pricePopover/components/PricePopoverOverlay";
import RouteTotalPrice from "@Route/components/Price/RouteTotalPrice";
import {extractAndParse} from "@Pages/stationToStation/features/pricePopover/functions/extractAndParse";

interface PricePopoverProps {
    routeId?: string,
    price?: number,
    preparedPrices?: Record<number, Record<number, number>>,
    passengerGroups?: any[]
    // ? is here so this can be used with PortalMap without errors
    index?: number,
}

function PricePopover(props: PricePopoverProps) {
    const {
        routeId,
        price = null,
        preparedPrices = null,
        passengerGroups = null,
        index,
    } = props

    return (
        <RouteTotalPrice price={price || extractAndParse(index, 'price')}/>
    )

    return (
        <GenericPopover
            trigger={(
                <PricePopoverTrigger
                    price={price}
                    index={index}
                />
            )}
            overlay={(
                <PricePopoverOverlay
                    index={index}
                    preparedPrices={preparedPrices}
                    passengerGroups={passengerGroups}
                />
            )}
            id={routeId ?? index}
        />
    );
}

export default PricePopover;